// components/Dashboard/TodayOrders.js
import React from "react";
import { Table } from "reactstrap";
import OrderStatusBadge from "components/Common/OrderStatusBadge";
import { Link } from "react-router-dom";

const TodayOrders = ({ orders, loading }) => {
  // Parse date from DD/MM/YYYY format
  const parseDate = (dateString) => {
    if (!dateString) return null;

    // Check if date is in DD/MM/YYYY format
    if (dateString.includes('/')) {
      const parts = dateString.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed
        const year = parseInt(parts[2], 10);
        return new Date(year, month, day);
      }
    }

    // Try parsing as ISO string or other format
    const parsed = new Date(dateString);
    return isNaN(parsed.getTime()) ? null : parsed;
  };

  // Format currency
  const formatCurrency = (amount) => {
    return `৳${parseFloat(amount || 0).toLocaleString('en-BD')}`;
  };

  // Format time
  const formatTime = (timeString, dateString) => {
    if (timeString) {
      // Extract hours and minutes from time string (HH:MM:SS)
      const timeParts = timeString.split(':');
      if (timeParts.length >= 2) {
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const displayHours = hours % 12 || 12;
        return `${displayHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
      }
    }

    // If no time, try to get from date
    if (dateString) {
      const date = parseDate(dateString);
      if (date) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      }
    }

    return "N/A";
  };

  // Get payment status badge
  const getPaymentBadge = (status) => {
    return (
      <span className={`badge ${status === 'paid' ? 'bg-success' : 'bg-danger'}`}>
        {status}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="text-center py-4">
        <i className="fas fa-shopping-cart fa-3x text-muted mb-3"></i>
        <h5>No orders placed today</h5>
        <p className="text-muted">Today's orders will appear here</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table hover className="mb-0">
        <thead className="table-light">
          <tr>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Products</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Payment</th>
            <th>Time</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id}>
              <td>
                <div className="">#00695{order.id}</div>
              </td>
              <td>
                <div className="d-flex flex-column">
                  <span className="fw-medium">{order.username}</span>
                  <small className="text-muted">{order.phonenumber}</small>
                  <small className="text-truncate" style={{ maxWidth: "150px" }}>
                    {order.address}
                  </small>
                </div>
              </td>
              <td>
                <div>
                  {order.orderproductdata?.slice(0, 2).map((product, index) => (
                    <div key={index} className="mb-1">
                      <small>
                        {index + 1}. {product.tytle}
                        {product?.power && product.power !== "none" ? ` (${product.power})` : ""}
                        <strong className="text-primary"> x{product.quantity}</strong>
                      </small>
                    </div>
                  ))}
                  {order.orderproductdata?.length > 2 && (
                    <small className="text-muted">
                      +{order.orderproductdata.length - 2} more items
                    </small>
                  )}
                </div>
              </td>
              <td>
                <span className="fw-semibold">{formatCurrency(order.totalamount)}</span>
              </td>
              <td>
                <OrderStatusBadge status={order.orderstatus} />
              </td>
              <td>{getPaymentBadge(order.paymentstatus)}</td>
              <td>
                <small className="text-muted">
                  {formatTime(order.ordertime, order.orderdate)}
                </small>
              </td>
              <td>
                <div className="d-flex gap-1">
                  <Link
                    to={`/order/${order.id}`}
                    className="btn btn-info btn-sm "
                    title="View Details"
                  >
                    <i className="fas fa-eye pt-1"></i>
                  </Link>
                  {/* <Link
                    to={`/orders/update-status/${order.id}`}
                    className="btn btn-outline-warning btn-sm"
                    title="Update Status"
                  >
                    <i className="fas fa-edit"></i>
                  </Link> */}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TodayOrders;